import React from 'react';
import { Drawer } from 'antd';
import { KeyOutlined, UserAddOutlined, NotificationOutlined, RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslator } from 'tools/view-hooks/translator-hook';
import { GiveAccessController } from 'fragments/passcodes/fragments/give-access/interfaces';
import { useGiveAccessController } from 'fragments/passcodes/fragments/give-access/give-access.controller';
import 'fragments/passcodes/fragments/give-access/give-access.scss';

interface GiveAccessFragmentProps {
    useController?: () => GiveAccessController;
}

export const GiveAccessFragment: React.FC<GiveAccessFragmentProps> = ({ useController = useGiveAccessController }) => {
    const { translate } = useTranslator();
    const navigate = useNavigate();
    const { state, events } = useController();

    const option = (iconMod: string, icon: React.ReactNode, title: string, desc: string, onClick: () => void) => (
        <button className={'give-access-option'} onClick={onClick}>
            <span className={`give-access-icon give-access-icon--${iconMod}`}>{icon}</span>
            <span style={{ flex: 1, minWidth: 0 }}>
                <span className={'give-access-optitle'} style={{ display: 'block' }}>
                    {title}
                </span>
                <span className={'give-access-opdesc'}>{desc}</span>
            </span>
            <RightOutlined aria-hidden style={{ color: 'rgba(0,0,0,0.25)' }} />
        </button>
    );

    return (
        <Drawer
            open
            placement={'bottom'}
            height={'auto'}
            title={translate({ key: 'give-access.title' })}
            onClose={() => navigate(-1)}
        >
            {option(
                'key',
                <KeyOutlined aria-hidden />,
                translate({ key: 'give-access.key-title' }),
                translate({ key: 'give-access.key-desc' }),
                events.onSelectKey,
            )}
            {option(
                'visitor',
                <UserAddOutlined aria-hidden />,
                translate({ key: 'give-access.visitor-title' }),
                translate({ key: 'give-access.visitor-desc' }),
                events.onSelectVisitor,
            )}
            {state.adminSites.length > 0 &&
                option(
                    'announcement',
                    <NotificationOutlined aria-hidden />,
                    translate({ key: 'give-access.announcement-title' }),
                    translate({ key: 'give-access.announcement-desc' }),
                    events.onSelectAnnouncement,
                )}
        </Drawer>
    );
};
